export const isRequired = (value) => {
    if (value === undefined || value === null || value === '') return 'Obrigatório'
    else return undefined
}